import { useCallback, useEffect } from 'react';

import CompleteInfoDialog from '@components/CompleteInfoDialog';
import { Footer } from '@components/Footer';
import { Header } from '@components/Header';
import { AppSidebar } from '@components/Sidebar';
import { SidebarProvider } from '@components/ui/sidebar';
import { WhatsAppButton } from '@components/WhatsAppButton';
import { pages } from '@constants/pages';
import { useAuth } from '@contexts/auth';
import { HeaderProvider } from '@contexts/header/provider';
import { ScrollProvider } from '@contexts/scroll/provider';
import { Navigate, Outlet, useLocation } from 'react-router';

import MenuSidebar from './Themes/Details/Sidebar';

declare const OneSignalDeferred: any;

function PrivateLayout() {
  const { authorization, user } = useAuth();
  const { pathname } = useLocation();

  const startOneSignal = useCallback(async (): Promise<void> => {
    if (!OneSignalDeferred) {
      return;
    }
    OneSignalDeferred.push(async function (OneSignal: any) {
      if (user?.email) {
        OneSignal.User.addEmail(user?.email);
      }
      if (user?.name) {
        const regex = /^[^\s]+/;
        const match = user.name.match(regex);
        if (match?.length) {
          OneSignal.User.addTag('first_name', match[0]);
        }
      }
      OneSignal.User.addTag('PLANO', user?.accessGranted ? 'PAGO' : 'GRATUITO');
      if (user?.occupationState) {
        OneSignal.User.addTag('UF', user.occupationState);
      }
      if (user?.occupationArea) {
        OneSignal.User.addTag('AREA_ATUACAO', user.occupationArea);
      }
      if (user?.yearGraduated) {
        OneSignal.User.addTag('ANO_FORMACAO', user.yearGraduated);
      }
    });
  }, [
    user?.accessGranted,
    user?.email,
    user?.name,
    user?.occupationArea,
    user?.occupationState,
    user?.yearGraduated,
  ]);

  useEffect(() => {
    if (user) {
      startOneSignal();
    }
  }, [startOneSignal, user]);

  if (!authorization.token) {
    return <Navigate replace to={pages.auth.signIn} />;
  }

  return (
    <SidebarProvider defaultLeftOpen={true} defaultRightOpen={false}>
      <HeaderProvider>
        <Header />
        {pathname.includes('/topicos/') && <MenuSidebar />}
        <ScrollProvider>
          <main className="mx-auto min-h-svh max-w-screen-xl px-4 py-4 md:px-8 md:py-8">
            <Outlet />
          </main>
          <Footer />
        </ScrollProvider>
        <WhatsAppButton />
        <AppSidebar />
        <CompleteInfoDialog />
      </HeaderProvider>
    </SidebarProvider>
  );
}

export default PrivateLayout;
